import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import GICRM from './components/GICRM';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <GICRM />
    </QueryClientProvider>
  );
}

export default App;
